"use client";

import { Box, Image } from "components";
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { helper } from "utils";

export default function PartnerLogo() {
  //const params = useSearchParams();
  const router = useRouter();

  const searchParams = new URLSearchParams(
    typeof window !== "undefined" ? window.location.search : ""
  );

  useEffect(() => {
    if (!searchParams.get("signUpCode")) {
      router.push("/bancochile/?signUpCode=BCH");
      const query = {};

      searchParams.forEach((value, key) => {
        query[key] = value;
      });
      helper.setToStorage("bup-query", { ...query, signUpCode: "BCH" });
    }
  }, []);

  return (
    <Box className="BupPartner-logo">
      <Image
        alt="Logo Banco de Chile"
        src="logos/banco.jpg"
        width={300}
        height={100}
      />
    </Box>
  );
}
